import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography,
} from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';
import TableItem from '../../Production/components/Table/TableItem';

const _palette = clientThemePalette[CLIENT_THEME];

interface Props {
  data: Array<{
    name: string;
    time: number | string;
    direction: string;
    color: string;
  }>;
  unit?: string;
  subItems?: any;
  onItemClick?: (itemName: string) => void;
  selectedItemName?: string | null;
}

const TableList = ({
  data,
  unit = 'Hours',
  subItems = {},
  onItemClick,
  selectedItemName,
}: Props) => {
  const { enableDarkTheme } = useAppTheme();
  const { t } = useTranslation();
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              borderBottom: `1px solid ${
                enableDarkTheme
                  ? _palette.dark.borderGrey
                  : _palette.light.borderGrey
              }`,
            }}
          >
            <Typography
              color={
                (enableDarkTheme ? _palette.dark : _palette.light).textSecondary
              }
              sx={{
                fontSize: '12px',
                fontWeight: '600',
              }}
            >
              {t('table_state')}
            </Typography>
          </TableCell>
          <TableCell
            align="right"
            sx={{
              borderBottom: `1px solid ${
                enableDarkTheme
                  ? _palette.dark.borderGrey
                  : _palette.light.borderGrey
              }`,
            }}
          >
            <Typography
              color={
                (enableDarkTheme ? _palette.dark : _palette.light).textSecondary
              }
              sx={{
                fontSize: '12px',
                fontWeight: '600',
              }}
            >
              {unit}
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((state, index) => {
          const subItem = subItems[state.name];
          return (
            <TableItem
              item={state}
              key={index}
              subItems={subItem}
              onItemClick={onItemClick}
              selectedItemName={selectedItemName}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

export default TableList;
